import { escapeHtml as esc } from './escapeHtml.js';
import { openCalificarVendedorModal } from './calificarVendedorModal.js';
import { mlvApplyZ } from './mlvZLayers.js';
import { mlvSaveFocus } from './mlvFocusRestore.js';
import { mlvModalHistoryAttach } from '../navigation/mlvModalHistoryBridge.js';
import {
  MLV_NOTIF_TIPO_AVISO_UBICACION,
  MLV_NOTIF_TIPO_MODERACION_ELIM,
  MLV_NOTIF_TIPO_RESENA,
  MLV_NOTIF_TIPO_TARJETA_SERVICIO,
} from './mlvResenaNotifBadges.js';

export function openNotificacionesResenaModal({
  items = [],
  calificacionesRepository,
  invalidateCatalogoCache,
  marcarLeida,
  uidComprador,
  ejecutarValidacionUbicacionGps = null,
} = {}) {
  return new Promise((resolve) => {
    const restoreFocus = mlvSaveFocus();
    const prev = document.getElementById('mlv-notif-resena-modal');
    if (prev) prev.remove();
    const pendientes = items.filter((n) => {
      if (n.leida === true) return false;
      if (n.tipo === MLV_NOTIF_TIPO_RESENA && String(n.vendedor_uid || '').trim()) return true;
      if (n.tipo === MLV_NOTIF_TIPO_AVISO_UBICACION) return true;
      if (n.tipo === MLV_NOTIF_TIPO_TARJETA_SERVICIO && String(n.profesional_uid || '').trim()) return true;
      if (n.tipo === MLV_NOTIF_TIPO_MODERACION_ELIM) return true;
      return false;
    });
    const wrap = document.createElement('div');
    wrap.id = 'mlv-notif-resena-modal';
    wrap.className =
      'fixed inset-0 flex items-end justify-center bg-black/55 p-4 sm:items-center';
    mlvApplyZ(wrap, 'notifResena');
    const lista =
      pendientes.length === 0
        ? `<p class="py-6 text-center text-sm text-slate-600">No tenés avisos pendientes.</p>`
        : `<ul id="mlv-notif-resena-list" class="max-h-[50vh] space-y-2 overflow-y-auto py-1"></ul>`;
    wrap.innerHTML = `
      <div class="w-full max-w-md rounded-t-3xl bg-white p-5 shadow-2xl ring-1 ring-slate-200/80 sm:rounded-3xl">
        <h3 class="font-heading text-lg font-bold text-slate-900">Notificaciones</h3>
        <p class="mt-1 text-xs text-slate-500">Reseñas pendientes y avisos del barrio (p. ej. reportes de ubicación).</p>
        <div class="mt-4">${lista}</div>
        <button type="button" id="mlv-notif-resena-cerrar" class="mt-5 w-full rounded-full border border-slate-300 py-2.5 text-sm font-semibold text-slate-700">Cerrar</button>
      </div>
    `;
    const hist = mlvModalHistoryAttach(() => {
      document.removeEventListener('keydown', onKey);
      try {
        restoreFocus();
      } catch (_e) {
        /* ignore */
      }
      wrap.remove();
    });
    function finish() {
      hist.closeFromUi();
      resolve();
    }
    function onKey(e) {
      if (e.key === 'Escape') finish();
    }
    const listEl = wrap.querySelector('#mlv-notif-resena-list');
    if (listEl) {
      for (const n of pendientes) {
        if (n.tipo === MLV_NOTIF_TIPO_TARJETA_SERVICIO) {
          const nom =
            String(n.profesional_nombre_snapshot || 'Un profesional').trim() || 'Un profesional';
          const titulo = String(n.titulo_caso || '').trim();
          const tid = String(n.tarjeta_id || '').trim();
          const li = document.createElement('li');
          li.className =
            'rounded-xl border border-slate-200 bg-slate-50/80 px-3 py-3 text-sm text-slate-800';
          li.innerHTML = `
            <p class="font-semibold text-slate-900">Te incluyeron en una tarjeta de servicio</p>
            <p class="mt-1.5 text-sm leading-relaxed text-slate-700">${esc(nom)} publicó un trabajo${
              titulo ? ` «${esc(titulo)}»` : ''
            }. Podés dejar una reseña dentro de 7 días.</p>
            <div class="mt-3 flex flex-wrap gap-2">
              <button type="button" class="mlv-notif-tarjeta-calif flex-1 rounded-full bg-brand-primary py-2 text-xs font-bold text-white">Calificar</button>
              <button type="button" class="mlv-notif-tarjeta-ok flex-1 rounded-full border border-slate-300 py-2 text-xs font-semibold text-slate-700">Cerrar</button>
            </div>`;
          li.querySelector('.mlv-notif-tarjeta-calif')?.addEventListener('click', async () => {
            if (!tid || !calificacionesRepository?.enviarResenaTarjetaServicio) {
              hist.closeFromUi();
              resolve();
              return;
            }
            hist.closeFromUi();
            await openCalificarVendedorModal({
              vendedorUid: String(n.profesional_uid || '').trim(),
              vendedorNombre: nom,
              productoId: '',
              calificacionesRepository,
              titulo: '¿Cómo fue el trabajo?',
              cuerpoHtml: `<p class="mt-2 text-sm text-slate-600">Tu calificación queda en la tarjeta pública del trabajo de <strong class="text-slate-800">${esc(
                nom
              )}</strong>. <strong class="text-slate-800">Una reseña por tarjeta.</strong></p>`,
              textoGraciasDetalle: 'Con tu opinión otros vecinos eligen mejor a los profesionales del barrio.',
              submitEstrellas: (s) =>
                calificacionesRepository.enviarResenaTarjetaServicio({
                  profesionalUid: String(n.profesional_uid || '').trim(),
                  tarjetaId: tid,
                  estrellas: s,
                }),
              invalidateCatalogoCache,
              onDespuesDeEnviar:
                n.id && uidComprador && marcarLeida
                  ? () => marcarLeida(uidComprador, n.id)
                  : undefined,
            });
            resolve();
          });
          li.querySelector('.mlv-notif-tarjeta-ok')?.addEventListener('click', async () => {
            if (n.id && uidComprador && marcarLeida) {
              try {
                await marcarLeida(uidComprador, n.id);
              } catch (_e) {
                /* ignore */
              }
            }
            finish();
          });
          listEl.appendChild(li);
          continue;
        }
        if (n.tipo === MLV_NOTIF_TIPO_AVISO_UBICACION) {
          const li = document.createElement('li');
          li.className =
            'rounded-xl border border-amber-200/90 bg-amber-50/80 px-3 py-3 text-sm text-slate-800';
          const msg = String(n.mensaje || n.titulo || '').trim() || 'Tenés un aviso en La Victoria Market.';
          const ctaGps = n.cta_validar_ubicacion === true && typeof ejecutarValidacionUbicacionGps === 'function';
          li.innerHTML = `
            <p class="font-semibold text-slate-900">${esc(String(n.titulo || 'Aviso'))}</p>
            <p class="mt-1.5 text-sm leading-relaxed text-slate-700">${esc(msg)}</p>
            <p class="mlv-notif-gps-hint mt-2 min-h-[1rem] text-xs font-medium text-amber-950"></p>
            ${
              ctaGps
                ? `<button type="button" class="mlv-notif-gps-btn mt-2 w-full rounded-full bg-brand-primary py-2 text-xs font-bold text-white">Validar ubicación con GPS</button>`
                : ''
            }
            <button type="button" class="mlv-notif-ubic-ok mt-3 w-full rounded-full bg-slate-800 py-2 text-xs font-bold text-white">Entendido</button>
          `;
          const hintEl = li.querySelector('.mlv-notif-gps-hint');
          const btnGps = li.querySelector('.mlv-notif-gps-btn');
          if (btnGps && ctaGps) {
            btnGps.addEventListener('click', async () => {
              btnGps.disabled = true;
              if (hintEl) hintEl.textContent = 'Obteniendo ubicación…';
              try {
                await ejecutarValidacionUbicacionGps();
                if (hintEl) hintEl.textContent = 'Ubicación validada. Gracias.';
                if (n.id && uidComprador && marcarLeida) {
                  try {
                    await marcarLeida(uidComprador, n.id);
                  } catch (_e) {
                    /* ignore */
                  }
                }
                window.setTimeout(() => finish(), 600);
              } catch (err) {
                if (hintEl) hintEl.textContent = String(err?.message || err || 'No se pudo validar.');
                btnGps.disabled = false;
              }
            });
          }
          li.querySelector('.mlv-notif-ubic-ok')?.addEventListener('click', async () => {
            if (n.id && uidComprador && marcarLeida) {
              try {
                await marcarLeida(uidComprador, n.id);
              } catch (_e) {
                /* ignore */
              }
            }
            finish();
          });
          listEl.appendChild(li);
          continue;
        }
        if (n.tipo === MLV_NOTIF_TIPO_MODERACION_ELIM) {
          const prodTit = String(n.producto_titulo_snapshot || '').trim();
          const msg = String(n.mensaje || '').trim() || 'Tu publicación fue eliminada por moderación.';
          const li = document.createElement('li');
          li.className =
            'rounded-xl border border-red-200/90 bg-red-50/60 px-3 py-3 text-sm text-slate-800';
          li.innerHTML = `
            <p class="font-semibold text-slate-900">${esc(String(n.titulo || 'Publicación eliminada'))}</p>
            ${
              prodTit
                ? `<p class="mt-1 text-xs font-medium text-slate-600">«${esc(prodTit)}»</p>`
                : ''
            }
            <p class="mt-2 text-sm leading-relaxed text-slate-700">${esc(msg)}</p>
            <button type="button" class="mlv-notif-mod-ok mt-3 w-full rounded-full bg-slate-800 py-2 text-xs font-bold text-white">Entendido</button>
          `;
          li.querySelector('.mlv-notif-mod-ok')?.addEventListener('click', async () => {
            if (n.id && uidComprador && marcarLeida) {
              try {
                await marcarLeida(uidComprador, n.id);
              } catch (_e) {
                /* ignore */
              }
            }
            finish();
          });
          listEl.appendChild(li);
          continue;
        }
        const nom = String(n.vendedor_nombre_snapshot || 'Un vendedor').trim() || 'Un vendedor';
        const li = document.createElement('li');
        li.className =
          'flex items-center justify-between gap-2 rounded-xl border border-slate-200 bg-slate-50/80 px-3 py-2.5';
        li.innerHTML = `
          <span class="min-w-0 text-sm text-slate-800">Calificá a <strong>${esc(nom)}</strong></span>
          <button type="button" class="shrink-0 rounded-full bg-brand-primary px-3 py-1.5 text-xs font-bold text-white">Calificar</button>
        `;
        const btn = li.querySelector('button');
        btn?.addEventListener('click', async () => {
          hist.closeFromUi();
          await openCalificarVendedorModal({
            vendedorUid: String(n.vendedor_uid || '').trim(),
            vendedorNombre: nom,
            productoId: String(n.producto_id || '').trim(),
            calificacionesRepository,
            invalidateCatalogoCache,
            onDespuesDeEnviar:
              n.id && uidComprador && marcarLeida
                ? () => marcarLeida(uidComprador, n.id)
                : undefined,
          });
          resolve();
        });
        listEl.appendChild(li);
      }
    }
    wrap.addEventListener('click', (e) => {
      if (e.target === wrap) finish();
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(wrap);
    wrap.querySelector('#mlv-notif-resena-cerrar')?.addEventListener('click', finish);
    requestAnimationFrame(() =>
      wrap.querySelector('#mlv-notif-resena-cerrar')?.focus?.({ preventScroll: true })
    );
  });
}
